module.exports = __webpack_public_path__ + "static/media/strom.24df1e92.svg";